export default "/images/performance.png?29a6f62fe0d8caa2932207c25deb04a5";